module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/ltv_features_04-dfbd5c345570559d5f1a3a6e0c76a5e8.png";